import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const ProfessionalTimeline: FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Professional features' showDay2={false} {...props} />
}
